import { AdvancedAddonsStyleData, BorderData, BoxShadowData } from '@/typings/interfaces/data/settings/settings';
import { AlignContentType, ImageSizeType, TransitionEnterType } from '@/typings/enums/enums';
import { ActionData } from '@/typings/interfaces/data/settings/actions';
import { DeviceData } from '@/hooks/useDevice';

export interface LayoutSettingsData {
  alignment: AlignContentType;
  overwrite_tablet?: string;
  overwrite_mobile?: string;
}

export interface ImageLayoutFilterData {
  opacity: string;
  blur: string;
  brightness: string;
  contrast: string;
  saturation: string;
  hue: string;
  enter?: TransitionEnterType;
  enter_duration?: string;
}

export interface ImageFilters {
  normal?: ImageLayoutFilterData;
  hover?: ImageLayoutFilterData;
}

export enum ImageSourceType {
  REPLACEMENT_TAG = 'use_replacement_tag',
  BROWSE = 'browse'
}

export interface AddonLfImageData {
  alias: string;
  icon: 'icon-addon-image';
  settings: {
    source?: string;
    source_type?: ImageSourceType;
    replacement_tag?: string;
    alt: string;
    size?: ImageSizeType;
    width?: string;
    height?: string;
    action: ActionData;
    layout: {
      settings: DeviceData<LayoutSettingsData>;
      filters: ImageFilters;
      border: DeviceData<BorderData>;
      shadow: DeviceData<BoxShadowData>;
    };
    advanced?: AdvancedAddonsStyleData;
  };
}
